import React from 'react';

/**
 * CityNavigationCard
 * Clickable block placed between top KPI stats ("Total Bookings" area) and Booking Overview.
 * Clicking it scrolls the page down to the City Explorer section (with down arrow affordance).
 */
const CityNavigationCard = ({ onClick, cityCount }) => {
  const handleClick = (e) => {
    e.preventDefault();
    if (typeof onClick === 'function') onClick();
  };

  return (
    <div
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { handleClick(e); } }}
      style={{
        cursor: 'pointer',
        borderRadius: 12,
        padding: '14px 16px',
        background: 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)',
        border: '1px solid #e2e8f0',
        boxShadow: '0 1px 3px rgba(15, 23, 42, 0.06)',
        marginBottom: 12,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        transition: 'transform 120ms ease, box-shadow 120ms ease, background 120ms ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-1px)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(15, 23, 42, 0.10)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = '';
        e.currentTarget.style.boxShadow = '0 1px 3px rgba(15, 23, 42, 0.06)';
      }}
      title="Click to search cities and areas in a popup modal"
    >
      <div style={{ fontSize: 22, lineHeight: 1, opacity: 0.9 }}>🏙️</div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 700, fontSize: 15, color: '#0f172a', letterSpacing: '-0.2px' }}>
          City Navigation
        </div>
        <div style={{ fontSize: 12, color: '#475569', marginTop: 1 }}>
          Browse areas, sublocalities &amp; stops • Mark on map
          {typeof cityCount === 'number' && cityCount > 0 ? ` • ${cityCount} cities` : ''}
        </div>
      </div>
      <div style={{
        width: 28,
        height: 28,
        borderRadius: 999,
        background: 'rgba(99, 102, 241, 0.12)',
        color: '#6366f1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 16,
        flexShrink: 0,
      }} aria-hidden>
        →
      </div>
    </div>
  );
};

export default CityNavigationCard;
